import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from '~/Constants/Routes.constants';
import { useCreatedPartnerPortalChecklist, useNavigation } from '~/Hooks';
import { Tour } from '~/Models/interfaces/Tour.enum';
import { clearProductTour, selectCurrentTour, setProductTour } from '~/store/app/productTours';
import { Typography } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { ProductTours } from '~/Components/ProductTours';
import { Meditation } from '~/Components/Icons/brand/Meditation';
import { ConfettiColorful } from '~/Components/Icons/ConfettiColorful';

const useStyles = makeStyles(
  () => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    text: {
      marginBottom: 30,
    },
  }),
  { name: 'EventProductTour' },
);

export const EventProductTour = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { navigate } = useNavigation();
  const { createdPartnerPortalChecklistItems } = useCreatedPartnerPortalChecklist();

  const dispatch = useDispatch();
  const currentTour = useSelector(selectCurrentTour);
  const setTour = bindActionCreators(setProductTour, dispatch);
  const clearTour = bindActionCreators(clearProductTour, dispatch);

  const onClose = () => {
    setTour(Tour.EVENT_CREATION_PENDING);
  };

  const isGoingBackToTheDashboard =
    createdPartnerPortalChecklistItems?.filter((item) => item.deactivated).length <= 1;

  const nextAction = () => {
    const nextItem = createdPartnerPortalChecklistItems.filter((item) => item.deactivated);
    clearTour();
    // the last item in the checklist is the approval process.
    if (nextItem.length > 1) {
      nextItem[0]?.onClick?.();
    } else {
      navigate(Route.HOME);
    }
  };

  if (currentTour === Tour.EVENT_CREATION) {
    return (
      <ProductTours
        icon={<Meditation />}
        title={t('tours.eventCreation.part1.title')}
        show={currentTour === Tour.EVENT_CREATION}
        onClose={onClose}
      >
        {t('tours.eventCreation.part1.description')}
      </ProductTours>
    );
  }
  if (currentTour === Tour.EVENT_CREATION_DONE) {
    return (
      <ProductTours
        icon={<ConfettiColorful />}
        title={t('app.fantastic')}
        show={currentTour === Tour.EVENT_CREATION_DONE}
        onClose={onClose}
        nextStep={{
          onClick: nextAction,
          actionName: t('tours.eventCreation.part2.addMore'),
        }}
        isGoingBackToTheDashboard={isGoingBackToTheDashboard}
      >
        <div className={classes.container}>
          <Typography className={classes.text}>
            {t('tours.eventCreation.part2.description')}
          </Typography>
        </div>
      </ProductTours>
    );
  }
  return null;
};
